import * as React from "react";
import { motion } from "framer-motion";
import TermsSection from "./TermsSection";

const TermsAndConditions = () => {
    return (
        <main className="flex flex-col items-center px-5 pt-60 pb-26 w-full bg-white min-h-[screen]">
            <article className="w-full max-w-[845px]">
                <motion.h1 className="mb-16 text-5xl font-bold text-center text-black max-md:text-4xl max-sm:text-3xl"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    Terms and Conditions
                </motion.h1>

                <motion.div className="flex flex-col gap-11"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <section className="flex flex-col gap-6">
                        <h2 className="text-lg font-bold text-black">
                            I Excel Management & Services Terms and Conditions
                        </h2>

                        <TermsSection
                            number="1"
                            title="Acceptance of Terms"
                            content="By enrolling in any program offered by I Excel Management & Services, you agree to be bound by these Terms and Conditions. These terms govern your use of our services and your relationship with us."
                        />
                    </section>

                    <TermsSection
                        number="2"
                        title="Program Enrollment"
                        content="Enrollment in any I Excel Management & Services program constitutes acceptance of these terms. All enrollments are subject to availability and approval by I Excel Management & Services."
                    />

                    <TermsSection
                        number="3"
                        title="Fees and Payment"
                        content="Tuition fees and payment schedules are outlined in the program details. Late payment may result in penalties as outlined in the program agreement."
                    />

                    <TermsSection
                        number="4"
                        title="Course Materials"
                        content="Course materials, including but not limited to textbooks and online resources, are the property of I Excel Management & Services and may not be reproduced or distributed without express written permission."
                    />

                    <TermsSection
                        number="5"
                        title="Student Conduct"
                        content="Students are expected to maintain respectful and professional conduct during all classes and interactions with instructors and staff. Disruptive behavior may result in disciplinary action, up to and including termination of enrollment."
                    />

                    <TermsSection
                        number="6"
                        title="Refunds and Cancellations"
                        content="Our refund policy is detailed in the program agreement. Cancellations must be made in accordance with the terms outlined in the program agreement."
                    />

                    <TermsSection
                        number="7"
                        title="Intellectual Property"
                        content="All intellectual property rights, including but not limited to copyrights and trademarks, related to I Excel Management & Services programs and materials, are the exclusive property of I Excel Management & Services."
                    />

                    <TermsSection
                        number="8"
                        title="Governing Law"
                        content="These Terms and Conditions shall be governed by and construed in accordance with the laws of Malaysia."
                    />

                    <TermsSection
                        number="9"
                        title="Amendments"
                        content="I Excel Management & Services reserves the right to modify these Terms and Conditions at any time. Updated terms will be posted on this page."
                    />

                    <TermsSection
                        number="10"
                        title="Contact Us"
                        content="For any questions or concerns regarding these Terms and Conditions, please contact us at info@iexcel.my or +6 (016) 293-2691."
                    />
                </motion.div>
            </article>
        </main>
    );
}

export default TermsAndConditions;
